import { FC } from 'react';

import styles from './MembershipStatusChangeDialog.module.scss';

type Props = {
  confirmAction: () => void;
  actionLabel: string;
};

const MembershipStatusChangeDialog: FC<Props> = ({ confirmAction, actionLabel }) => {
  return (
    <div className={styles.dialog_inner}>
      <p className={styles.dialog_alert_text}>加盟状態を変更しますか？</p>
      <p className={styles.dialog_action_text}>「{actionLabel}」を実行します</p>
      <button className={styles.confirm_button} onClick={() => confirmAction()}>
        実行
      </button>
    </div>
  );
};

export default MembershipStatusChangeDialog;
